var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('baidu-map',{attrs:{"center":_vm.center,"scroll-wheel-zoom":true,"zoom":_vm.zoom},on:{"ready":_vm.handler}},[_c('bm-view',{staticClass:"map"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }